// extracted by mini-css-extract-plugin
export var bodySections = "_42-8";
export var gray = "_42-7";
export var green = "_42-4";
export var iconContainer = "_42-9";
export var iconWidgetContainer = "_42-1";
export var phoneIcon = "_42-2";
export var red = "_42-5";
export var statusDot = "_42-3";
export var widgetContainer = "_42-0";
export var yellow = "_42-6";